let APP_AWS_REGION = "us-east-1";
let BUCKET_FILES = "sam-telcel-audiencias-validation-files";
let BUCKET_EXTERNAL_VIP = "sam-telcel-audiencias-black-lists-vip-files";
let BUCKET_EXTERNAL_DEUR = "sam-telcel-audiencias-black-lists-deur-files";

export { APP_AWS_REGION, BUCKET_FILES ,BUCKET_EXTERNAL_VIP,BUCKET_EXTERNAL_DEUR};